<template>
  <div v-if="userinfo" class="index_wrap">
    <van-pull-refresh class="refresh" v-model="refreshing" @refresh="onRefresh">
      <userinfos v-if="userinfo" :data="userinfo" source="index"></userinfos>
      <div v-if="userinfo" class="assets">
        <div @click="jump" class="arrow">
          <div class="lable">总资产</div>
          <div class="price">{{ userinfo.balance.toLocaleString() || 0 }}</div>
        </div>
      </div>
      <div class="section">
        <div v-for="(item, index) in list" :key="index" class="item">
          <router-link :to="item.to">
            <div class="img">
              <img :src="item.img" alt="" />
            </div>
            <div class="title">{{ item.title }}</div>
            <div v-if="item.code" class="desc">
              {{ item.codename }}<span>{{ userinfo[item.code] || 0 }}</span
              >{{ index == 0 ? '场' : '件' }}
            </div>
          </router-link>
        </div>
      </div>
      <!-- <div style="width: 93.6%;margin: 20px auto 0;">
        <img
          alt
          width="100%"
          @click="toMpActivity"
          src="https://img.zai-art.com/zaiart/saas/image/md/027541991a4e6c99e2f16037e3f1cef8.png"
        />
      </div> -->
    </van-pull-refresh>
    <van-action-sheet
      v-model="liveActivityObj.showSheet"
      :actions="liveActivityObj.actions"
      cancel-text="取消"
      close-on-click-action
      @select="onActionSelected"
    />
  </div>
</template>
<script>
import userinfos from './common/userinfos';
import { getMain, getShopinfos } from '@/api/index';
import Cookies from 'js-cookie';

export default {
  name: 'index',
  components: { userinfos },
  data() {
    return {
      refreshing: false,
      liveActivityObj: {
        showSheet: false,
        actions: [{ name: '进入活动主要' }, { name: '进入活动助力页' }],
      },
      list: [
        {
          title: '直播管理',
          img: 'https://img.zai-art.com/zaiart/saas/image/md/0576dd78513a5772a7be071f4293feb1.png',
          to: '/live/list',
          codename: '待直播',
          code: 'liveCount',
        },
        {
          title: '商品管理',
          img: 'https://img.zai-art.com/zaiart/saas/image/md/6837ba56da0b2e54bd902fbdee824d37.png',
          to: '/goods/list',
          codename: '售卖中',
          code: 'goodCount',
        },
        {
          title: '拍品管理',
          img: 'https://img.zai-art.com/zaiart/saas/image/md/e5b7871bb4a6df719d222d52421667ee.png',
          to: '/auction/list',
          codename: '竞拍中',
          code: 'biddingCount',
        },
        {
          title: '商品订单管理',
          img: 'https://img.zai-art.com/zaiart/saas/image/md/21009daef4079e109be7a96552dc75d6.png',
          to: '/order/good/list',
        },
        {
          title: '拍卖订单管理',
          img: 'https://img.zai-art.com/zaiart/saas/image/md/d4ac90de4052c28fae64efe7947855e3.png',
          to: '/order/auction/list',
        },
        {
          title: '保证金订单管理',
          img: 'https://img.zai-art.com/zaiart/saas/image/md/79cf971909163f593f76770e93958538.png',
          to: '/order/margin/list',
        },
      ],
    };
  },
  computed: {
    userinfo() {
      Cookies.set('userShopinfos', JSON.stringify(this.$store.state.app.userinfos));
      return this.$store.state.app.userinfos;
    },
  },
  methods: {
    jump() {
      this.$router.push({ path: '/capital/index' });
    },
    onRefresh() {
      getMain().then(res => {
        this.refreshing = false;
        this.$store.commit('setUserinfos', res.data);
      });
    },
    toMpActivity() {
      if (this.userinfo.hasJoin) {
        this.liveActivityObj.showSheet = true;
      } else {
        this.onActionSelected(null, 0);
      }
    },
    onActionSelected(action, index) {
      if (index == 1) {
        let path = encodeURIComponent(`/pages/power/index?id=${this.$store.state.app.shopId}`);
        let title = encodeURIComponent(`进入活动助力页`);
        wx.miniProgram.navigateTo({
          url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${title}`,
        });
      } else {
        let path = encodeURIComponent(`/pages/power/web`);
        let title = encodeURIComponent(`进入活动主页`);
        wx.miniProgram.navigateTo({
          url: `/pages/openMini/index?path=${path}&appid=wx85f3340de9840fb8&title=${title}`,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.index_wrap {
  padding-top: 12px;
  background: #f8f8f8;
  position: relative;
  background: url('https://img.zai-art.com/zaiart/saas/image/md/823f78a797a2979ff23203944e19dbe6.png')
    no-repeat top;
  background-size: 100% 100px;
  min-height: 100vh;
  .assets {
    width: 93.6%;
    margin: 0 auto;
    padding: 22px 20px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222222;
    line-height: 16px;
    background: #fff;
    margin-bottom: 12px;
    .arrow {
      width: 100%;
      background: url('https://img.zai-art.com/zaiart/saas/image/md/fe6b998bf9b73861cd4b50cedac3e3f7.png')
        no-repeat right;
      background-size: 18px 18px;
      display: flex;
      justify-content: space-between;
      padding-right: 18px;
    }
    .price {
      color: #3276fc;
    }
  }
  .section {
    width: 93.6%;
    margin: 0 auto;
    background: #fff;
    padding: 25px 0;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 10px;
    &::after {
      content: '';
      width: 33%;
      height: 0px;
      visibility: hidden;
    }
    .item {
      width: 33%;
      display: inline-block;
      text-align: center;
      margin-bottom: 15px;
      text-align: center;
      .img {
        width: 60px;
        height: 60px;
        // background: #f8f8f8;
        margin: 0 auto;
        margin-bottom: 15px;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
      }
      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 14px;
        margin-bottom: 3px;
      }
      .desc {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
        span {
          color: #3276fc;
        }
      }
    }
  }
  .refresh {
    height: calc(100vh - 54px);
  }
}
</style>
